import React, { useEffect, useState } from 'react'
import { Layout, Menu } from 'antd'
import { useHistory, Switch, Route } from 'react-router-dom'
import UserInfo from './user_info'
import CollectionsCom from './collections'
import UploadCom from './uploads'
import SuggestionCom from './suggestions'
import MessageCom from './messages'
import { UserMenuMap } from './user_menu'
import './user.less'
import './messages.less'
import './suggestions.less'
import SearchBar from 'components/SearchBar'
import TeacherCom from './teachers'
import EditPasswordCom from './edit_password'
import OldPasswordFormCom from './oldPassword_form'
import PhoneFormCom from './phone_form'
import BindPhoneCom from './bind_phone'
import { useSelector } from 'react-redux'
import { IState } from 'reducers'
import AgreeCom from './agree' 

const UserCom = () => {
  const { Sider, Content } = Layout
  const history = useHistory()
  const [selectedKey, setSelectedKey] = useState('')
  const user = useSelector((state: IState) => state.user)
  // 选择并高亮用户导航
  const selectKey = ({ key }) => {
    let path = key
    history.push(path)
    setKey(key)
  }
  const setKey = (key: string) => {
    setSelectedKey(key)
  }
  useEffect(() => {
    let path = history.location.pathname
    if (path.includes('/user/edit_password')) {
      setKey('/user/info')
    } else if (path.includes('/user/old_password_form')) {
      setKey('/user/info')
    } else if (path.includes('/user/phone_form')) {
      setKey('/user/info')
    } else if (path.includes('/user/bind_phone')) {
      setKey('/user/info')
    } else {
      setKey(path)
    }
  }, [history.location.pathname])

  const [userType, setUserType] = useState('')
  useEffect(() => {
    setUserType(user.type)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.type])

  return (
    <>
      <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/user-banner.png)` }}>
        <SearchBar module="User Center" />
      </div>
      <div className="layout-content-mask">
        <div className="layout-content-bg-LB"></div>
        <div className="layout-content-bg-RT"></div>
        <Layout className="user-layout">
          <Sider theme="light" className="user-layout-sider" width={240}>
            <Menu
              onClick={selectKey}
              selectedKeys={[selectedKey]}
              defaultSelectedKeys={['/user/info']}
            >
              {userType === '' ? (
                <></>
              ) : (
                UserMenuMap[userType].map(item => (
                  <Menu.Item key={item.path} className="user-menu-item">
                    <span style={{ marginRight: 12 }}>{item.icon}</span>
                    <span>{item.name}</span>
                  </Menu.Item>
                ))
              )}
            </Menu>
          </Sider>
          <Content className="user-layout-content">
            <Switch>
              <Route path="/user/info" component={UserInfo}></Route>
              <Route path="/user/edit_password" component={EditPasswordCom}></Route>
              <Route path="/user/old_password_form" component={OldPasswordFormCom}></Route>
              <Route path="/user/phone_form" component={PhoneFormCom}></Route>
              <Route path="/user/bind_phone" component={BindPhoneCom}></Route>
              <Route path="/user/collections" component={CollectionsCom}></Route>
              <Route path="/user/uploads" component={UploadCom}></Route>
              <Route path="/user/suggestions" component={SuggestionCom}></Route>
              <Route path="/user/messages" component={MessageCom}></Route>
              <Route path="/user/teachers" component={TeacherCom}></Route>
              <Route path="/user/agree" component={AgreeCom}></Route>
            </Switch>
          </Content>
        </Layout>
      </div>
    </>
  )
}

export default UserCom
